<umkt-auth-layout>
  <div class="auth-back">
    <a routerLink="/login">
      <mat-icon>chevron_left</mat-icon>
      {{ 'pages.forgotPassword.backToLogin' | i18n }}
    </a>
  </div>
  <div class="auth-card-content">
    <div class="auth-card-form">
      <div class="auth-intern-form">
        <div class="auth-title font-highlight">
          <h1>{{ 'pages.login.title' | i18n }} <span class="auth-title-highlight">{{ 'pages.login.titleHighlight' | i18n }}</span></h1>
        </div>
        
        <p class="auth-desc">{{ 'pages.forgotPassword.description' | i18n }}</p>
        
        <form [formGroup]="forgotForm" class="auth-form">
          <umkt-custom-input 
            formControlName="email" 
            type="email" 
            [ariaLabel]="('pages.forgotPassword.email' | i18n) + '*'" 
            [placeholder]="'pages.forgotPassword.email' | i18n"
            [maxlength]="255">
          </umkt-custom-input>

          <ustore-button [type]="'button'" [format]="'filled'" [backgroundColor]="'var(--color-red-500-to-yellow)'" [textColor]="'var(--color-inverted)'"
            [size]="'medium'" [rounded]="'default'" [text]="(loading ? 'pages.forgotPassword.sending' : 'pages.forgotPassword.submit') | i18n"
            [icon]="{ name: loading ? 'hourglass_empty' : 'email', type: 'material-icons', position: 'left' }"
            [full]="true" 
            [disabled]="forgotForm.invalid || loading" 
            (click)="sendRecovery()">
          </ustore-button>

          <div class="auth-register">
            {{ 'pages.forgotPassword.noAccount' | i18n }} <a routerLink="/register">{{ 'pages.forgotPassword.register' | i18n }}</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</umkt-auth-layout>